import { useQuery } from '@tanstack/react-query';

import { api } from '..';

export const applicationKeys = {
	all: ['application'],
	getApplicationVersions: () => [...applicationKeys.all, 'versions'],
	getPublicApplicationVersions: (type: string) => [...applicationKeys.all, 'public-versions', type],
} as const;

export const useGetApplicationVersions = () =>
	useQuery({
		queryKey: applicationKeys.getApplicationVersions(),
		queryFn: async () => await api.application.getApplicationVersions(),
	});

export const useGetPublicApplicationVersions = (type: string) =>
	useQuery({
		queryKey: applicationKeys.getPublicApplicationVersions(type),
		queryFn: async () => await api.application.getPublicApplicationVersions(type),
	});
